import React, { useEffect, useState, useRef, useContext } from "react";
import "react-toastify/dist/ReactToastify.css";
import styles from "./StatusBtn.module.scss";

const StatusBtn = ({
  warningIcon,
  successIcon,
  errorIcon,
  infoIcon,
  notifyIcon,
  greyIcon,
  title,
  status = "",
}) => {
  return (
    <>
      {status === "Success" ? (
        <span className={`${styles["successBtn"]}`}>
          <img src={successIcon} /> {title}
        </span>
      ) : status === "Warning" ? (
        <span className={`${styles["warningBtn"]}`}>
          <img src={warningIcon} /> {title}
        </span>
      ) : status === "Error" ? (
        <span className={`${styles["errorBtn"]}`}>
          <img src={errorIcon} /> {title}
        </span>
      ) : status === "Error_1" ? (
        <span className={`${styles["errorBtn_1"]}`}>
          <img src={errorIcon} /> {title}
        </span>
      ) : status === "Error_2" ? (
        <span className={`${styles["errorBtn_2"]}`}>
          <img src={errorIcon} /> {title}
        </span>
      ) : status === "Info" ? (
        <span className={`${styles["infoBtn"]}`}>
          <img src={infoIcon} /> {title}
        </span>
      ) : status === "Notify" ? (
        <span className={`${styles["notifyBtn"]}`}>
          <img src={notifyIcon} /> {title}
        </span>
      ) : status === "Grey" ? (
        <span className={`${styles["greyBtn"]}`}>
          <img src={greyIcon} /> {title}
        </span>
      ) : (
        ""
      )}
    </>
  );
};

export default StatusBtn;
